import { useLayoutEffect, useRef } from "react"

import { Flex, Modal } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { DisclaimerKai } from "@/molecules/DisclaimerKai"
import { DescriptionAlert } from "./components/DescriptionAlert"
import { Flow } from "./components/Flow"

import styles from "./DataFlow.module.scss"

import type { DataFlowProps } from "./DataFlow.types"

export const DataFlow = (props: DataFlowProps) => {
  const { open, data, isLoading, onClose } = props
  const { description, isFalsePositive } = data || {}
  const { flows } = data || { flows: [] }
  const { t } = useTranslation()
  const refContent = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    if (!open) return

    const root = document.getElementsByClassName(styles.modal)[0]

    if (!root) return

    const body = root.querySelector(".ant-modal-body") as HTMLElement
    const modal = root.querySelector(".ant-modal") as HTMLElement

    if (!body) return

    const documentHeight = window.innerHeight

    const contentMaxHeight = refContent.current?.clientHeight || 0
    const padding = 24

    if (contentMaxHeight < body.clientHeight)
      body.style.maxHeight = `${contentMaxHeight + padding}px`
    else body.style.maxHeight = `${documentHeight - padding}px`

    if (documentHeight - modal.clientHeight <= padding * 2) {
      modal.style.top = `${padding}px`
    }
  }, [open])

  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      width={710}
      rootClassName={styles.modal}
      title={
        <Flex vertical>
          <span>{t("triage.drawer.dataFlow.title")}</span>
          <span className={styles.kai}>
            {t("triage.drawer.kai.customFix.subtitle")}
          </span>
        </Flex>
      }
      footer={
        <Flex align="center">
          <DisclaimerKai />
        </Flex>
      }
    >
      <Flex vertical gap={4} ref={refContent}>
        <DescriptionAlert
          description={description}
          isFalsePositive={isFalsePositive}
          isLoading={isLoading}
        />
        {flows.map((flow, index) => (
          <Flow key={index} {...flow} />
        ))}
      </Flex>
    </Modal>
  )
}
